import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]

  connect() {
    this.initLightbox()
    this.boundCleanup = () => this.destroyLightbox()
    document.addEventListener("turbo:before-cache", this.boundCleanup)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.boundCleanup)
    this.destroyLightbox()
  }

  async initLightbox() {
    const { default: PhotoSwipeLightbox } = await import("photoswipe/lightbox")

    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.displayTarget,
      children: ".swiper-slide img",
      pswpModule: () => import("photoswipe"),

      secondaryZoomLevel: 2,
      maxZoomLevel: 4,
      tapAction: "zoom",
      closeOnVerticalDrag: true,

      bgOpacity: 0.95,
      padding: { top: 20, bottom: 20, left: 20, right: 20 },
    })

    this.lightbox.addFilter("domItemData", (itemData, element) => {
      itemData.src = element.src
      itemData.w = element.naturalWidth || 1200
      itemData.h = element.naturalHeight || 1200
      itemData.msrc = element.src
      return itemData
    })

    this.lightbox.init()
  }

  destroyLightbox() {
    if (this.lightbox) {
      this.lightbox.destroy()
      this.lightbox = null
    }
  }
}
